import React from "react";
import { FormFeedback, Input, Label } from "reactstrap";

const InputCustom = ({lblInput, inputName, inputType, inputPlaceholder, validation, disabled}) => {
    return (
        <React.Fragment>
            <div className="mb-3">
                            <Label className="form-label">{lblInput}</Label>
                            <Input disabled={disabled}
                                name={inputName}
                                type={inputType}
                                placeholder={inputPlaceholder}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values[inputName] || ""}
                                invalid={
                                    validation.touched[inputName] &&
                                        validation.errors[inputName]
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched[inputName] &&
                                validation.errors[inputName] ? (
                                <FormFeedback type="invalid">
                                    {validation.errors[inputName]}
                                </FormFeedback>
                            ) : null}
                        </div>
        </React.Fragment>
    );
};

export default InputCustom;